import { render, staticRenderFns } from "./StaffAdd.vue?vue&type=template&id=f84b3a00"
import script from "./StaffAdd.vue?vue&type=script&lang=js"
export * from "./StaffAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports